module.exports = __webpack_public_path__ + "img/visao.7715a2a5.svg";